import $ from "jquery";
import { Component, ParentComponent, Renderable } from "../../components/Component";
import template from "./page.hbs";

export class LiveDesignSystem implements Component, ParentComponent {
    public componentType = "liveDesignSystemPage";
    public id;
    private view;
    public definition;
    public children = [];

    constructor(definition) {
        this.definition = definition;
    }

    public render(): Element {
        // const renderedRows = [];
        // for (let rowDef of this.definition.rows) {
        //     let component = new LDSRow(rowDef.title, JSON.stringify(rowDef.definition, null, "\t"));
        //     this.children.push(component);
        //     renderedRows.push(component.render());
        // }

        let d: Element = document.createElement("div");
        d.innerHTML = template(this.definition);
        let rendered: Element = d.firstChild as Element;

        let children: Map<string, Node[]> = new Map();
        // children.set("ldsRows", renderedRows);
        // this.addChildren(rendered, children);
        this.view = rendered;
        return rendered;
    }


    public postRender() {
        // $.each(this.children, (key, component) => {
        //     if (component.postRender) {
        //         component.postRender();
        //     }
        // });
    }

    private addChildren(node: Element, children: Map<string, Node[]>): Node {
        for (let key of Array.from(children.keys())) {
            let placeHolder: Element = node.querySelector('[data-child-placeholder="ldsRows"]');
            for (let child of children.get(key)) {
                placeHolder.parentNode.insertBefore(child, placeHolder);
            }
        }
        return node;
    }

    public appendChildView = (childView: Node): void => {
        $(childView).appendTo(this.view);
    }
}
